import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Stack from '@mui/material/Stack/Stack';
import Typography from '@mui/material/Typography/Typography';

import ModalNotification from '@/shared/components/dialogs/ModalNotification';
import { AppPath } from '@/shared/constants/path';

type OrderCancelledWarningDialogProps = {
  orderId: string;
  onCreateNewOrderClick: () => void;
};

const OrderCancelledWarningDialog: FC<OrderCancelledWarningDialogProps> = ({
  orderId,
  onCreateNewOrderClick,
}) => {
  const { t } = useTranslation(['checkout']);

  const navigate = useNavigate();

  return (
    <ModalNotification
      size='sm'
      fullWidth
      open
      dialogProps={{
        title: t('checkout:orderCancelled'),
        content: (
          <Stack sx={{ p: 1 }} spacing={2}>
            <Typography variant='body1'>
              {t('checkout:orderCancelledMessage')}
            </Typography>
          </Stack>
        ),
        actions: [
          {
            label: t('checkout:viewOrderDetails'),
            variant: 'text',
            onClick: () => {
              navigate(`${AppPath.Orders}/${orderId}`);
            },
          },
          {
            label: t('checkout:createNewOrder'),
            variant: 'contained',
            onClick: onCreateNewOrderClick,
          },
        ],
      }}
    />
  );
};

export default OrderCancelledWarningDialog;
